export const SET_BILLING_MONTHS = 'setBillingMonths';
export const SET_PRICING_PLAN = 'setPricingPlan';
export const SET_BILLING_PLAN = 'setBillingPlan';
export const SET_CREDIT_CARDS = 'setCreditCards';
export const SET_BILLING_SETTINGS = 'setBillingSettings';